import React from 'react';

import { ActionIcon, Group, useMantineTheme } from '@mantine/core';
import { IconEdit, IconTrashX } from '@tabler/icons-react';
import type { Row } from 'react-table';
import type { PackageUtilizationExpectationListItem } from 'types';

import { useModal } from '../../../Context';

type ActionsColumnProps = {
  row: Row<PackageUtilizationExpectationListItem>;
};

const ActionsColumn = ({ row }: ActionsColumnProps): JSX.Element => {
  const { openModal } = useModal();
  const theme = useMantineTheme();

  return (
    <Group spacing='xs' position='right' px='xs' noWrap>
      <ActionIcon variant='transparent' color='gray' onClick={() => openModal('edit', row.original)}>
        <IconEdit size={theme.fontSizes.xl} />
      </ActionIcon>
      <ActionIcon variant='transparent' color='gray' onClick={() => openModal('delete', row.original)}>
        <IconTrashX size={theme.fontSizes.xl} />
      </ActionIcon>
    </Group>
  );
};

export default ActionsColumn;
